// @flow

import { SimpleEntity } from '../abstract/SimpleEntity';
import type { EntityFieldCollection } from '../types';
import OpeningHoursPeriod from './OpeningHoursPeriod';

class OpeningHours implements SimpleEntity {
    static fields: EntityFieldCollection = {
        day: {
            displayName: 'Day',
            recordName: 'day',
            dataType: {
                primitive: 'enum',
                isArray: false,
                extraData: {
                    1: 'Mon',
                    2: 'Tue',
                    3: 'Wed ',
                    4: 'Thu',
                    5: 'Fri',
                    6: 'Sat',
                    7: 'Sun',
                },
            },
            isOptional: false,
        },
        periods: {
            displayName: 'Periods',
            recordName: 'periods',
            dataType: {
                primitive: 'simple-entity',
                isArray: true,
                extraData: {
                    model: () => OpeningHoursPeriod,
                    maxValues: null,
                },
            },
            isOptional: false,
        },
    };

    constructor(record: any) {
        this.record = record;
    }
}

export default OpeningHours;
